import { pickBy } from 'lodash'

const pickNonEmpty = (obj?: Record<string, unknown>) => {
  const x = pickBy(obj, (v) => v !== undefined)
  return Object.keys(x).length !== 0 ? x : null
}

export default pickNonEmpty
